<template>
    <li class="dd-m-menu__item dd-m-menu__item--logout" v-if="signed">
        <a class="dd-m-menu__link" v-on:click.prevent="signOut()">
            <i class="dd-m-icon icon-squares"></i>
            <span>Sair</span>
        </a>
    </li>
</template>
<script>
    import AuthService from '../../providers/api/auth-service';

    const api = new AuthService();

    export default {
        name: 'auth-logout',
        data: () => {
            return {
                signed: false
            }
        },
        mounted() {
            this.checkSign();
            this.subscribe();
        },
        methods: {
            checkSign() {
                this.signed = this.isSignedIn();
            },
            isSignedIn() {
                return localStorage.token;
            },
            signOut() {
                api.doSignOut()
                    .then(() => {
                        delete localStorage.token;
                        delete localStorage.accessToken;
                        PubSub.publish('updatedSign');
                    });
            },
            subscribe() {
                PubSub.subscribe('updatedSign', () => this.checkSign());
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/auth-logout.vue